__webpack_require__.p = "https://cdn.bioclinica.ro/prod/5679b029/_next/";